import React, { useEffect, useState } from "react";
import { Link, NavLink, useNavigate, useParams } from "react-router-dom";
import { Variables } from "../../Variations/Variations";
import { toast } from "react-toastify";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Util from "../../Classes/Util";
import axios from "axios";
import ReactPaginate from "react-paginate";
import Dropzone from "react-dropzone";
import { Button, Modal, Tabs, Tab } from "react-bootstrap";
import { AiOutlineRight } from "react-icons/ai";
import {
  MdManageSearch,
  MdOutlineAssignmentReturned,
  MdOutlineDelete,
} from "react-icons/md";
import DataTable from "react-data-table-component";
const ManageBrand = () => {
  //#region Variables
  const permissions = Util.decrypt(localStorage.getItem("Permissions"));
  let { BrandID } = useParams();
  let navigate = useNavigate();
  const [brandName, setBrandName] = useState("");
  const [parentID, setParentID] = useState(0);
  const [isFeatured, setIsFeatured] = useState(false);
  const [isPublished, setIsPublished] = useState(false);
  const [brandDetails, setBrandDetails] = useState();
  const [parentBrands, setParentBrands] = useState([]);
  const [thumbnail, setThumbnail] = useState(0);
  const [Media, setMedia] = useState([]);
  const [showingThumbnail, setShowingThumbnail] = useState("");
  const [show, setShow] = useState(false);
  const [filteredData, setFilteredData] = useState(Media);
  const [assignedMeasurements, setAssignedMeasurements] = useState([]);
  const [filteredAssignedMeasurements, setFilteredAssignedMeasurements] =
    useState([]);
  const [unassignedMeasurements, setUnassignedMeasurements] = useState([]);
  const [filteredUnassignedMeasurements, setFilteredUnassignedMeasurements] =
    useState([]);
  const [isOpenAssignMeasurement, setIsOpenAssignMeasurement] = useState(false);
  const [assignedSizes, setAssignedSizes] = useState([]);
  const [filteredAssignedSizes, setFilteredAssignedSizes] = useState([]);
  const [unassignedSizes, setUnassignedSizes] = useState([]);
  const [filteredUnassignedSizes, setFilteredUnassignedSizes] = useState([]);
  const [isOpenAssignSize, setIsOpenAssignSize] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const LIMIT = 18;
  //#endregion Variables

  //#region Handlers
  useEffect(() => {
    setCurrentPage(0);
  }, [filteredData]);
  function handleImage(id, image) {
    setThumbnail(id);
    setShowingThumbnail(image);
    setShow(false);
  }
  const offset = currentPage * LIMIT;
  const currentData = filteredData.slice(offset, offset + LIMIT);
  const pageCount = Math.ceil(filteredData.length / LIMIT);

  const handleDrop = async (files) => {
    
    var count = 0;
    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      let reader = new FileReader();
      if (files[i].size >= 2000000) {
        count = count + 1;
      } else {
        reader.onload = async function () {
          const formData = new FormData();
          formData.append("Image", files[i]);
          try {
            const res = await axios.post(
              Variables.API_URL + "UploadMedia/UploadImageToServer",
              formData
            );
            if (res.data !== "") {
              await fetch(Variables.API_URL + "UploadMedia/InsertMedia", {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({
                  image: res.data,
                  imageTitle: files[i].name.split(".").slice(0, -1).join("."),
                  altText: "",
                  description: "",
                  caption: "",
                }),
              }).then((Response) => {
                if (Response.ok) {
                  fetchMedia();
                } else {
                  toast.error(Response);
                }
              });
            }
          } catch (ex) {
            console.log(ex);
          }
        };
        reader.readAsDataURL(file);
      }
    }

    if (count === 1) {
      var error1 = " Image is not accepted ";
      toast.error(error1);
    } else if (count > 1) {
      var error2 = count + " Images are not accepted ";
      toast.error(error2);
    }
  };
  const handleSearch = (event) => {
     setCurrentPage(0);
    let value = event.target.value.toLowerCase();
    let result = [];
    result = Media.filter((data) => {
      return data.ImageTitle.search(value) != -1;
    });
    setFilteredData(result);
   
  };
  function fetchMedia() {
    fetch(Variables.API_URL + "UploadMedia/GetMedia", {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((Response) => Response.json())
      .then((Result) => {
        setMedia(Result);
        setFilteredData(Result);
      });
  }
  function IsValid() {
    if (brandName == "") {
      toast.error("Please fill all required fields!");
      return false;
    }
    if (thumbnail == 0) {
      toast.error("Please choose an imgae");
      return false;
    }
    return true;
  }
  function HandleSubmit(e) {
    e.preventDefault();
    if (IsValid()) {
      e.preventDefault();
      if (BrandID == 0) {
        const addBrand = async () => {
          let response = await fetch(Variables.API_URL + "Brand/AddBrand", {
            method: "Post",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              Brand1: brandName,
              ParentId: parentID,
              IsFeatured: isFeatured,
              IsPublished: isPublished,
              Description: brandDetails,
              Thumbnail: thumbnail,
            }),
          });
          let result = await response.json();
          if (response.status === 200) {
            fetch(
              Variables.API_URL + "Brand/AssignMeasurementToBrand/" + result,
              {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(
                  assignedMeasurements.map((item) => ({
                    MeasurementId: item.MeasurementId,
                  }))
                ),
              }
            );
            fetch(Variables.API_URL + "Brand/AssignSizeToBrand/" + result, {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(
                assignedSizes.map((item) => ({
                  SizeId: item.SizeId,
                }))
              ),
            });
            toast.success("Added Successfully");
            setTimeout(() => {
              navigate("/admin/gazelle/Brand");
            }, 600);
          } else {
            toast.error(result);
          }
        };
        setTimeout(() => {
          (async () => await addBrand())();
        }, 100);
      } else {
        const updateBrand = async () => {
          let response = await fetch(
            Variables.API_URL + "Brand/UpdateBrand/" + BrandID,
            {
              method: "Put",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                Brand1: brandName,
                ParentId: parentID,
                IsFeatured: isFeatured,
                IsPublished: isPublished,
                Description: brandDetails,
                Thumbnail: thumbnail,
              }),
            }
          );
          let result = await response.json();
          if (response.status === 200) {
            fetch(
              Variables.API_URL + "Brand/AssignMeasurementToBrand/" + BrandID,
              {
                method: "POST",
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(
                  assignedMeasurements.map((item) => ({
                    MeasurementId: item.MeasurementId,
                  }))
                ),
              }
            );
            fetch(Variables.API_URL + "Brand/AssignSizeToBrand/" + BrandID, {
              method: "POST",
              headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
              },
              body: JSON.stringify(
                assignedSizes.map((item) => ({
                  SizeId: item.SizeId,
                }))
              ),
            });
            toast.success(result);
            setTimeout(() => {
              navigate("/admin/gazelle/Brand");
            }, 600);
          } else {
            toast.error(result);
          }
        };
        setTimeout(() => {
          (async () => await updateBrand())();
        }, 100);
      }
    }
  }

  //#endregion Handlers

  async function GetBrands(brandID) {
    const URL = Variables.API_URL + "Brand/GetBrand/" + brandID;
    const response = await fetch(URL);
    if (!response.ok) throw Error("Did Not Receive expected data");
    const listItems = await response.json();
    setBrandName(listItems.Brand1);
    setParentID(listItems.ParentId);
    setIsPublished(listItems.IsPublished);
    setIsFeatured(listItems.IsFeatured);
    setThumbnail(listItems.Thumbnail);
    setShowingThumbnail(listItems.ShowingThumbnail);
    setBrandDetails(
      listItems.Description === null ? "" : listItems.Description
    );
  }
  async function GetParentBrands() {
    const URL = Variables.API_URL + "Brand/GetParentBrands/" + BrandID;
    const response = await fetch(URL);
    if (!response.ok) throw Error("Did Not Receive expected data");
    const listItems = await response.json();
    setParentBrands(listItems);
  }

  async function GetUnassignedMeasurements() {
    const URL =
      Variables.API_URL + "Brand/GetUnAssignedMeasurements/" + BrandID;
    const response = await fetch(URL);
    if (!response.ok) throw Error("Did Not Receive expected data");
    const listItems = await response.json();
    setUnassignedMeasurements(listItems);
    setFilteredUnassignedMeasurements(listItems);
  }
  async function GetAssignedMeasurements() {
    const URL = Variables.API_URL + "Brand/GetAssignedMeasurements/" + BrandID;
    const response = await fetch(URL);
    if (!response.ok) throw Error("Did Not Receive expected data");
    const listItems = await response.json();
    setAssignedMeasurements(listItems);
    setFilteredAssignedMeasurements(listItems);
  }

  function handlSearchAssignedMeasurement(e) {
    let value = e.target.value.toLowerCase();
    let result = [];
    result = assignedMeasurements.filter((data) => {
      return data.MeasurementValue.toLowerCase().search(value) != -1;
    });
    setFilteredAssignedMeasurements(result);
  }
  function handleSearchUnassignedMeasurement(e) {
    let value = e.target.value.toLowerCase();
    let result = [];
    result = unassignedMeasurements.filter((data) => {
      return data.MeasurementValue.toLowerCase().search(value) != -1;
    });
    setFilteredUnassignedMeasurements(result);
  }

  function AssignMeasurement(row) {
    var assigned = [...assignedMeasurements];
    assigned.push(row);
    var unassigned = [...unassignedMeasurements];
    unassigned.forEach((element, i) => {
      if (element == row) {
        unassigned.splice(i, 1);
      }
    });
    setAssignedMeasurements(assigned);
    setFilteredAssignedMeasurements(assigned);
    setFilteredUnassignedMeasurements(unassigned);
    setUnassignedMeasurements(unassigned);
    setIsOpenAssignMeasurement(false);
  }

  function UnassignMeasurement(row) {
    var assigned = [...assignedMeasurements];
    var unassigned = [...unassignedMeasurements];
    assigned.forEach((element, i) => {
      if (element == row) {
        assigned.splice(i, 1);
      }
    });
    unassigned.push(row);
    unassigned.sort((a, b) => a.MeasurementId - b.MeasurementId);
    setAssignedMeasurements(assigned);
    setUnassignedMeasurements(unassigned);
    setFilteredAssignedMeasurements(assigned);
    setFilteredUnassignedMeasurements(unassigned);
  }

  const unassignedMeasurementsColumns = [
    {
      name: "ID",
      selector: (row) => row.MeasurementId,
      sortable: true,
    },
    {
      name: " Value ",
      selector: (row) => row.MeasurementValue,
      sortable: true,
    },

    {
      name: "Assign",
      selector: (row) => (
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => AssignMeasurement(row)}
        >
          <MdOutlineAssignmentReturned />
        </button>
      ),
    },
  ];
  const assignedMeasurementsColumns = [
    {
      name: "ID",
      selector: (row) => row.MeasurementId,
      sortable: true,
    },
    {
      name: " Value ",
      selector: (row) => row.MeasurementValue,
      sortable: true,
    },

    {
      name: "UnAssign",
      selector: (row) => (
        <button
          className="btn btn-outline-danger btn-sm"
          onClick={() => UnassignMeasurement(row)}
        >
          <MdOutlineDelete />
        </button>
      ),
    },
  ];

  async function GetUnassignedSizes() {
    const URL = Variables.API_URL + "Brand/GetUnassignedSizes/" + BrandID;
    const response = await fetch(URL);
    if (!response.ok) throw Error("Did Not Receive expected data");
    const listItems = await response.json();
    setUnassignedSizes(listItems);
    setFilteredUnassignedSizes(listItems);
  }
  async function GetAssignedSizes() {
    const URL = Variables.API_URL + "Brand/GetAssignedSizes/" + BrandID;
    const response = await fetch(URL);
    if (!response.ok) throw Error("Did Not Receive expected data");
    const listItems = await response.json();
    setAssignedSizes(listItems);
    setFilteredAssignedSizes(listItems);
  }

  function handleSearchAssignedSizes(e) {
    let value = e.target.value.toLowerCase();
    let result = [];
    result = assignedSizes.filter((data) => {
      return data.Name.toLowerCase().search(value) != -1;
    });
    setFilteredAssignedSizes(result);
  }
  function handleSearchUnassignedSizes(e) {
    let value = e.target.value.toLowerCase();
    let result = [];
    result = unassignedSizes.filter((data) => {
      return data.Name.toLowerCase().search(value) != -1;
    });
    setFilteredUnassignedSizes(result);
  }

  function AssignSize(row) {
    var assigned = [...assignedSizes];
    assigned.push(row);
    var unassigned = [...unassignedSizes];
    unassigned.forEach((element, i) => {
      if (element == row) {
        unassigned.splice(i, 1);
      }
    });
    setAssignedSizes(assigned);
    setFilteredAssignedSizes(assigned);
    setFilteredUnassignedSizes(unassigned);
    setUnassignedSizes(unassigned);
    setIsOpenAssignSize(false);
  }

  function UnassignSize(row) {
    var assigned = [...assignedSizes];
    var unassigned = [...unassignedSizes];
    assigned.forEach((element, i) => {
      if (element == row) {
        assigned.splice(i, 1);
      }
    });
    unassigned.push(row);
    unassigned.sort((a, b) => a.SizeId - b.SizeId);
    setAssignedSizes(assigned);
    setUnassignedSizes(unassigned);
    setFilteredAssignedSizes(assigned);
    setFilteredUnassignedSizes(unassigned);
  }

  const unassignedSizesColumns = [
    {
      name: "ID",
      selector: (row) => row.SizeId,
      sortable: true,
    },
    {
      name: " Value ",
      selector: (row) => row.Name,
      sortable: true,
    },

    {
      name: "Assign",
      selector: (row) => (
        <button
          className="btn btn-outline-secondary btn-sm"
          onClick={() => AssignSize(row)}
        >
          <MdOutlineAssignmentReturned />
        </button>
      ),
    },
  ];
  const assignedSizesColumns = [
    {
      name: "ID",
      selector: (row) => row.SizeId,
      sortable: true,
    },
    {
      name: " Value ",
      selector: (row) => row.Name,
      sortable: true,
    },

    {
      name: "UnAssign",
      selector: (row) => (
        <button
          className="btn btn-outline-danger btn-sm"
          onClick={() => UnassignSize(row)}
        >
          <MdOutlineDelete />
        </button>
      ),
    },
  ];

  //#region Use Effect
  useEffect(() => {
    if (BrandID != 0) {
      GetBrands(BrandID);
      GetAssignedMeasurements();
      GetAssignedSizes();
    }
    GetUnassignedMeasurements();
    GetUnassignedSizes();
    GetParentBrands();
    fetchMedia();
  }, []);
  //#endregion Use Effect
  return (
    <div className="rightSide">
      <div className="container-fluid mt-3">
        <div className="row">
          <div className="col-12">
            <h2>{BrandID == "0" ? "Add" : "Update"} Brand</h2>
            <ul className="portalPath">
              <li>
                Home <AiOutlineRight />
              </li>
              <li>
                <Link to="/admin/gazelle/Brand">
                  Brands <AiOutlineRight />
                </Link>
              </li>
              <li>Manage Brand</li>
            </ul>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="card">
                <div className="card-header">
                  <div className="row">
                    <div className="col-8">
                      <h3>{brandName}</h3>
                    </div>
                    <div className="col-4 text-right">
                      <NavLink to="/admin/gazelle/Brand" className="btn btn-secondary">
                        Cancel
                      </NavLink>
                      <button
                        type="submit"
                        className="btn btn-primary ms-2"
                        onClick={HandleSubmit}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
                <div className="card-body">
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-12 col-sm-6 col-md-4 col-lg-3 mt-2">
                        <label>Brand Name</label>
                        <input
                          className="form-control required"
                          placeholder="Brand Name"
                          required
                          value={brandName}
                          onChange={(e) => setBrandName(e.target.value)}
                        ></input>
                      </div>
                      <div className="col-12 col-sm-6 col-md-4 col-lg-3 mt-2">
                        <label>Parent</label>
                        <select
                          className="form-control"
                          onChange={(e) => setParentID(e.target.value)}
                          value={parentID}
                        >
                          <option key="0" value="0">
                            Root Brand
                          </option>
                          {parentBrands.map((x) => (
                            <option key={x.BrandId} value={x.BrandId}>
                              {x.Brand1}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-12 col-sm-6 col-md-4 col-lg-3 mt-2">
                        <label>Products Order</label>
                        <select className="form-control">
                          <option key="0" value={"0"}>
                            Order Products By
                          </option>
                        </select>
                      </div>
                      <div className="col-2 mt-2">
                        <input
                          type="checkbox"
                          id="isFeatured"
                          onChange={(e) =>
                            setIsFeatured(
                              e.target.checked == true ? true : false
                            )
                          }
                          checked={isFeatured}
                        />
                        <label htmlFor="isFeatured" className="ml-3">
                          Featured
                        </label>
                        <br />
                        {permissions.PublishBrand === true ? (
                          <>
                            <input
                              type="checkbox"
                              id="isPublished"
                              onChange={(e) =>
                                setIsPublished(
                                  e.target.checked == true ? true : false
                                )
                              }
                              checked={isPublished}
                            />
                            <label htmlFor="isPublished" className="ml-3">
                              Published
                            </label>
                          </>
                        ) : null}
                      </div>
                      <div className="col-12 mt-2">
                        <label>Description</label>
                        <CKEditor
                          editor={ClassicEditor}
                          data={brandDetails}
                          onReady={(editor) => {
                            // You can store the "editor" and use when it is needed.
                          }}
                          onChange={(event, editor) => {
                            const data = editor.getData();
                            setBrandDetails(data);
                          }}
                        />
                      </div>
                      <div className="col-12 col-sm-6 col-md-4 col-lg-12 mt-2">
                        <label> Brand Image</label> <br />
                        <Button
                          className="me-2 btn btn-secondary btn-sm "
                          onClick={() => setShow(true)}
                        >
                          Add Brand Image
                        </Button>
                        <Modal show={show} onHide={() => setShow(false)}>
                          <Modal.Header closeButton>
                            <Modal.Title>
                              Add images to product gallery
                            </Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <Tabs
                              defaultActiveKey="Library"
                              id="uncontrolled-tab-example"
                              className="mb-3"
                            >
                              <Tab eventKey="Upload" title="Upload File">
                                <div className="row mt-5">
                                  <div className="row">
                                    <Dropzone
                                      onDrop={handleDrop}
                                      accept="image/jpeg,image/png,image/jpg,image/svg"
                                      style={{ height: 500 }}
                                    >
                                      {({ getRootProps, getInputProps }) => (
                                        <div
                                          {...getRootProps({
                                            className: "dropzone",
                                          })}
                                        >
                                          <input {...getInputProps()} />
                                          <p style={{ height: 500 }}>
                                            Drag'n'drop images, or click to
                                            select files
                                          </p>
                                        </div>
                                      )}
                                    </Dropzone>
                                  </div>
                                  <div className="row">
                                    <br />
                                  </div>
                                </div>
                              </Tab>
                              <Tab eventKey="Library" title="Media Library">
                                <div className="col-12">
                                  <div className="container-fluid">
                                    <div className="row">
                                      <div className="col-3">
                                        <input
                                          type="search"
                                          className="form-control"
                                          onChange={(e) => handleSearch(e)}
                                          placeholder={"Search media by name"}
                                        />
                                      </div>
                                    </div>
                                    <br />
                                  </div>
                                </div>
                                <div className="col-12">
                                  {/* Grid */}
                                  <div className="row">
                                    {currentData.map((image) => (
                                      <div
                                        className="col-2"
                                        key={image.MediaId}
                                      >
                                        <div className="imagecontainer">
                                          <div className="form-check">
                                            <button className="btn">
                                              <img
                                                alt="media"
                                                className="form-control"
                                                src={
                                                  Variables.API_PUBLISHED +
                                                  image.Image
                                                }
                                              />
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    ))}
                                  </div>
                                  {/* Pagination */}
                                  <div className="d-flex justify-content-center mt-4">
                                    <ReactPaginate
                                      pageCount={pageCount}
                                      onPageChange={({ selected }) =>
                                        setCurrentPage(selected)
                                      }
                                      pageRangeDisplayed={4}
                                      marginPagesDisplayed={1}
                                      previousLabel={null}
                                      nextLabel={null}
                                      containerClassName="pagination"
                                      pageClassName="page-item"
                                      pageLinkClassName="page-link"
                                      activeClassName="active"
                                      breakLabel="..."
                                    />
                                  </div>
                                </div>
                              </Tab>
                            </Tabs>
                          </Modal.Body>
                        </Modal>
                      </div>
                      <div className="col-12 col-sm-6 col-md-4 col-lg-12 mt-2 text-center">
                        {thumbnail !== 0 ? (
                          <img
                            className="form-control"
                            style={{ width: "300px", margin: "auto" }}
                            src={Variables.API_PUBLISHED + showingThumbnail}
                          />
                        ) : null}
                      </div>
                      <br />
                      <div className="card">
                        <div className="card-header">
                          <div className="row">
                            <div className="col-6">
                              <h5 className="card-title">
                                Assigned Measurements
                              </h5>
                            </div>
                            <div className="col-6 text-right">
                              <button
                                className="btn btn-primary"
                                onClick={() => setIsOpenAssignMeasurement(true)}
                              >
                                Assign Measurement
                              </button>
                              <Modal
                                dialogClassName="w-max"
                                show={isOpenAssignMeasurement}
                                onHide={() => setIsOpenAssignMeasurement(false)}
                              >
                                <Modal.Header closeButton>
                                  <Modal.Title>Assign Request</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <div className="container">
                                    <div className="row">
                                      <div className="col-12">
                                        <div className="row mb-3">
                                          <div className="col-8"></div>
                                          <div className="col-4 text-end tblSearchBar position-relative">
                                            <span>
                                              <MdManageSearch />
                                            </span>
                                            <input
                                              type="text"
                                              placeholder="Search any field in table"
                                              className="form-control form-control-sm"
                                              onChange={(e) =>
                                                handleSearchUnassignedMeasurement(
                                                  e
                                                )
                                              }
                                            ></input>
                                          </div>
                                        </div>
                                        <div className="portalTable">
                                          <DataTable
                                            columns={
                                              unassignedMeasurementsColumns
                                            }
                                            data={
                                              filteredUnassignedMeasurements
                                            }
                                            pagination
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Modal.Body>
                                <Modal.Footer>
                                  <div className="container">
                                    <div className="row">
                                      <div className="col-12 text-right">
                                        <Button
                                          variant="secondary"
                                          onClick={() =>
                                            setIsOpenAssignMeasurement(false)
                                          }
                                        >
                                          Close
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                </Modal.Footer>
                              </Modal>
                            </div>
                          </div>
                        </div>

                        <div className="card-body">
                          <div className="row mb-3">
                            <div className="col-8"></div>
                            <div className="col-4 text-end tblSearchBar position-relative">
                              <span>
                                <MdManageSearch />
                              </span>
                              <input
                                type="text"
                                placeholder="Search any field in table"
                                className="form-control form-control-sm"
                                onChange={(e) =>
                                  handlSearchAssignedMeasurement(e)
                                }
                              ></input>
                            </div>
                          </div>
                          <div className="portalTable">
                            <DataTable
                              columns={assignedMeasurementsColumns}
                              data={filteredAssignedMeasurements}
                              pagination
                            />
                          </div>
                        </div>
                      </div>
                      <br />
                      <div className="card">
                        <div className="card-header">
                          <div className="row">
                            <div className="col-6">
                              <h5 className="card-title">Assigned Sizes</h5>
                            </div>
                            <div className="col-6 text-right">
                              <button
                                className="btn btn-primary"
                                onClick={() => setIsOpenAssignSize(true)}
                              >
                                Assign Size
                              </button>
                              <Modal
                                dialogClassName="w-max"
                                show={isOpenAssignSize}
                                onHide={() => setIsOpenAssignSize(false)}
                              >
                                <Modal.Header closeButton>
                                  <Modal.Title>Assign Request</Modal.Title>
                                </Modal.Header>
                                <Modal.Body>
                                  <div className="container">
                                    <div className="row">
                                      <div className="col-12">
                                        <div className="row mb-3">
                                          <div className="col-8"></div>
                                          <div className="col-4 text-end tblSearchBar position-relative">
                                            <span>
                                              <MdManageSearch />
                                            </span>
                                            <input
                                              type="text"
                                              placeholder="Search any field in table"
                                              className="form-control form-control-sm"
                                              onChange={(e) =>
                                                handleSearchUnassignedSizes(e)
                                              }
                                            ></input>
                                          </div>
                                        </div>
                                        <div className="portalTable">
                                          <DataTable
                                            columns={unassignedSizesColumns}
                                            data={filteredUnassignedSizes}
                                            pagination
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </Modal.Body>
                                <Modal.Footer>
                                  <div className="container">
                                    <div className="row">
                                      <div className="col-12 text-right">
                                        <Button
                                          variant="secondary"
                                          onClick={() =>
                                            setIsOpenAssignSize(false)
                                          }
                                        >
                                          Close
                                        </Button>
                                      </div>
                                    </div>
                                  </div>
                                </Modal.Footer>
                              </Modal>
                            </div>
                          </div>
                        </div>

                        <div className="card-body">
                          <div className="row mb-3">
                            <div className="col-8"></div>
                            <div className="col-4 text-end tblSearchBar position-relative">
                              <span>
                                <MdManageSearch />
                              </span>
                              <input
                                type="text"
                                placeholder="Search any field in table"
                                className="form-control form-control-sm"
                                onChange={(e) => handleSearchAssignedSizes(e)}
                              ></input>
                            </div>
                          </div>
                          <div className="portalTable">
                            <DataTable
                              columns={assignedSizesColumns}
                              data={filteredAssignedSizes}
                              pagination
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ManageBrand;
